var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "project-options" },
    [
      _c(
        "PageHeaderOptions",
        {
          attrs: {
            allowChangePIC: _vm.allowChangePIC,
            allowCancel: _vm.allowCancel,
            showSubstitute:
              _vm.isFinalRequestApproved &&
              _vm.isPIC &&
              !_vm.isProjectCompleted,
            previousPersonInCharge: _vm.currentPersonInCharge,
            confirmCancelMsg: _vm.$t("hint.cancelProject"),
            itemName: _vm.$t("project.name"),
            site: _vm.site,
          },
          on: {
            "change-pic": function (val) {
              return _vm.changeProjectPIC(val)
            },
            cancelItem: function ($event) {
              return _vm.cancelProject()
            },
          },
        },
        [
          _vm.isFinalRequestApproved && _vm.isPIC
            ? _c("li", { attrs: { slot: "substitute" }, slot: "substitute" }, [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isProjectCompleted,
                        expression: "!isProjectCompleted",
                      },
                    ],
                    staticClass: "btn--transparent",
                    on: {
                      click: function ($event) {
                        return _vm.dispatchCompleteAction()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.complete")))]
                ),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("HKLModal", {
        ref: "actualCompDateModal",
        attrs: {
          title: _vm.$t("project.actualCompDate.forceInputMsg"),
          closable: true,
          hasCancelBtn: false,
        },
      }),
      _vm._v(" "),
      _c("HKLModal", {
        ref: "dlpDateReminder",
        attrs: {
          title: _vm.$t("hint.project.withoutDLP"),
          okBtnAction: "yesComplete",
          cancelBtnAction: "goback",
        },
        on: { onOkClick: _vm.completeProject },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }